import React, { PureComponent, ReactNode } from 'react';
import styled, { withTheme } from 'styled-components';
import em from 'polished/lib/helpers/em';
import { Waypoint } from 'react-waypoint';
import { TextAnimation } from '@flow/components/animation/TextAnimation';

const Title = styled.h1`
  font-family: Flow-Inverted;
  font-size: 10em;
  text-align: center;
  text-transform: uppercase;
  padding: ${em(10, 10)} ${em(3, 10)} ${em(8.6, 10)};
  
  @media (max-width: 1920px) {
    font-size: ${100/(1920*0.01)}vw;
  }
  
  @media (max-width: 1000px) {
    font-size: 5em;
  }
`;

interface Props {
  title: string;
  theme?: any;
}

interface State {
  animateTitleIn: boolean;
  canRenderTitle: boolean;
}

class SectionTitle extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      animateTitleIn: false,
      canRenderTitle: false
    }
  }

  componentDidMount() {
    this.setState({canRenderTitle: true});
  }

  private _handleWaypointEnter = () => {
    this.setState({
      animateTitleIn: true
    })
  };

  render() {
    const {
      title
    } = this.props;

    const { canRenderTitle } = this.state;

    return (
      <React.Fragment>
        {title && canRenderTitle &&
          this._renderTitle(title)
        }
      </React.Fragment>
    );
  }

  private _renderTitle = (title: string): ReactNode => {
    const {
      theme: {
        isMobile
      }
    } = this.props;

    if (!isMobile) {
      return (
        <Waypoint onEnter={this._handleWaypointEnter}>
          <Title>
            <TextAnimation text={title} animationType={'horizontal-slide'} animateIn={this.state.animateTitleIn}/>
          </Title>
        </Waypoint>
      )
    } else {
      return (
        <Title>{title}</Title>
      )
    }
  }
}

export default withTheme(SectionTitle);


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/scenes/home/components/section-title/SectionTitle.tsx